// Module
var code = "<mx-horizontal-action-list ng-if=\"vm.actions.length && vm.isVisible && !vm.sideLayoutService.fullScreenMode\" actions=\"vm.actions\" action-list-aria-label=\"{{:: 'shell.mx-common-actions.ARIA-title' | mxi18n }}\">\r\n</mx-horizontal-action-list>\r\n";
// Exports
export default code;